import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckBlue = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M25.5 4.475L11.2375 18.75L5.9375 13.45L7.7 11.6875L11.2375 15.225L23.7375 2.725L25.5 4.475ZM22.7375 10.775C22.9 11.4875 23 12.2375 23 13C23 18.525 18.525 23 13 23C7.475 23 3 18.525 3 13C3 7.475 7.475 3 13 3C14.975 3 16.8 3.575 18.35 4.5625L20.15 2.7625C18.125 1.3375 15.6625 0.5 13 0.5C6.1 0.5 0.5 6.1 0.5 13C0.5 19.9 6.1 25.5 13 25.5C19.9 25.5 25.5 19.9 25.5 13C25.5 11.5125 25.225 10.0875 24.75 8.7625L22.7375 10.775Z",
		fill: "#6565EC"
	})
});
export { SvgCheckBlue as ReactComponent };
